// Each `id` is the API field name and must never be translated; the labels are
// resolved at call time so they follow the active language.
const EXPORT_FIELD_IDS = [
  { id: "id", defaultChecked: false },
  { id: "username", defaultChecked: true },
  { id: "nickname", defaultChecked: true },
  { id: "role", defaultChecked: true },
  { id: "email", defaultChecked: true },
  { id: "phone", defaultChecked: true },
  { id: "cpf", defaultChecked: true },
  { id: "plans", defaultChecked: true },
  { id: "created_at", defaultChecked: true },
];

const EXPORT_FIELD_LABEL = (t) => ({
  id: t("exportMembers.fields.options.id"),
  username: t("common:fields.username"),
  nickname: t("exportMembers.fields.options.nickname"),
  role: t("exportMembers.fields.options.role"),
  email: t("exportMembers.fields.options.email"),
  phone: t("common:fields.phone"),
  cpf: t("common:fields.cpf"),
  plans: t("exportMembers.fields.options.plans"),
  created_at: t("exportMembers.fields.options.createdAt"),
});

export const getExportFields = (t) => {
  const labels = EXPORT_FIELD_LABEL(t);
  return EXPORT_FIELD_IDS.map((field) => ({
    ...field,
    label: labels[field.id],
  }));
};

export const DEFAULT_EXPORT_FIELDS = EXPORT_FIELD_IDS
  .filter((f) => f.defaultChecked)
  .map((f) => f.id);
